import React from 'react';
import { ResponsivePie } from '@nivo/pie';

import { rawValue } from '../helpers/getRawValue';
import { category10 } from '../helpers/colors';

import fields from '../schemas/pie-chart-fields.json';

const fieldsArray = Object.keys(fields);

const buildData = counts => Object.keys(counts).reduce((acc, curr) => (
  curr !== 'total' ? [
    ...acc,
    {
      id: curr,
      label: fields[curr].label || curr,
      value: parseFloat(((counts[curr] / counts.total) * 100).toFixed(1)),
      realValue: counts[curr],
    },
  ] : acc
), []);

const getCounts = zone => fieldsArray.reduce((acc, field) => {
  const value = rawValue(zone, field);
  if (!value) {
    return acc;
  }

  return {
    ...acc,
    [field]: value,
    total: (acc.total || 0) + value,
  };
}, {});

const ZoneJobDistrib = ({ zone, active, showLabels, style = {}, ...props }) => {
  const counts = getCounts(zone);
  const data = buildData(counts);

  const offColor = 'rgb(200, 200, 200)';
  const colorBy = ({ id } = {}) => (
    active && active !== id
      ? offColor
      : category10[fieldsArray.findIndex(field => field === id)]
  );
  const colorLinkBy = ({ data: node } = {}) => colorBy(node);

  return (
    <div
      style={{
        height: 300,
        ...style,
      }}
    >
      <ResponsivePie
        data={data}
        sortByValue
        padAngle={1}
        cornerRadius={3}
        innerRadius={0.7}
        margin={{ top: 25, bottom: 25 }}
        colorBy={colorBy}
        radialLabelsLinkColor={colorLinkBy}
        radialLabelsLinkStrokeWidth={2}
        borderWidth={1}
        borderColor="inherit:darker(0.5)"
        enableRadialLabels={showLabels}
        radialLabel="label"
        radialLabelsSkipAngle={10}
        slicesLabelsSkipAngle={15}
        sliceLabel={({ value }) => `${value} %`}
        {...props}
      />
    </div>
  );
};

export default ZoneJobDistrib;
